<script>
export default {
    name: 'RequestItems',
    props: {
        items: {
            type: Array,
            required: true
        },
        withActions: {
            type: Boolean,
            default: false,
        },
        busy: Boolean,
    },
    computed: {
        filtered(){
            let data = this.items;
            var total = this.currentPage * this.perPage;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            var currentData = data.slice(total - this.perPage, total);
            if (this.currentPage > 1 && currentData.length == 0) {
                total = (this.currentPage - 1) * this.perPage;
                currentData = data.slice(total - this.perPage, total);
            }
            return currentData;
        },
        rows(){
            let data = this.items;
            if (this.filter.trim() != "" && this.filter) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            return data.length;
        }
    },
    data(){
        return {
            filter: '',
            perPage: 10,
            pageOptions: [10, 30, 50, 100],
            currentPage: 1,
        }
    },
    methods: {
        deleteItem(item){
            this.$emit('deleteItem', item)
        },
        selectItem(item){
            this.$emit('select-item', item)
        },
    }
}
</script>
<template>
  <div>
    <div v-if="busy">Loading...</div>
    <div v-if="!busy && !items.length">No data found...</div>
    <div v-if="!busy && items.length">
        <div id="tickets-table_filter" class="dataTables_filter mb-2">
            <label class="d-inline-flex align-items-center mb-0">
                <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search Item..."
                    class="form-control me-1"
                ></b-form-input>
                <b-form-select
                    class="form-select"
                    v-model="perPage"
                    :options="pageOptions"
                    style="width:70px;"
                ></b-form-select>
            </label>
        </div>
        <div v-for="(item, index) in filtered" :key="item.id">
            <div class="card mb-2" :style="`z-index:${items.length - index}`" :class="{'cursor-pointer': !withActions}" @click="selectItem(item)">
                <div class="card-body py-1 position-relative hover-toggle">
                    <div class="my-2" >
                        <h5 class="mb-0">{{item.item.itemName}}</h5>
                        <p class="mb-0 text-ellipsis">{{item.item.description}}</p>
                        <div class="d-flex justify-content-between">
                            <div>
                                <span class="badge bg-primary bg-soft me-1">{{item.item.unit.unitName}}</span>
                                <span class="badge bg-primary bg-soft me-1">{{item.item.subType}}</span>
                                <span class="badge bg-primary bg-soft">{{item.item.itemCategory.name}}</span>
                            </div>
                            <div class="text-right">
                                <p class="mb-0 font-size-15 text-green font-weight-bold">{{formatCurrency(item.item.unitCost)}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="text-right hover-content" v-if="withActions">
                        <a href="javascript:void(0);" class="text-danger" @click="deleteItem(item)"><i class="bx bx-trash"></i> Remove from Cart</a>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!filtered.length">Search not found...</div>
        <div class="text-center mt-4" v-if="filtered.length">
            <ul
                class="
                    pagination
                    justify-content-end
                "
            >
                <b-pagination
                    size="sm"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                ></b-pagination>
            </ul>
        </div>
    </div>
  </div>
</template>